<template>
  <div class="bg-white" style="padding: 15px">
    <el-row>
      <el-col :sm="12" v-if="user.isRole([1, 2])">
        <div>
          <el-upload
            class="mb-1"
            :action="api.href"
            :file-list="fileList"
            accept=".csv"
            :headers="api.headers"
            :on-success="handleSuccess"
            :show-file-list="false"
          >
            <el-button type="primary" icon="el-icon-upload" size="small"
              >Batch Upload</el-button
            >
          </el-upload>
        </div>

      </el-col>
      
      <el-col :sm="{ span: 12, offset: !user.isRole([1, 2]) ? 12 : 0 }">
        <el-form
          class="text-right"
          :inline="true"
          @submit.native.prevent="fetch(1)"
          size="small"
        >
          <el-form-item>  
            <!-- <el-input
              v-model="pager.search"
              placeholder="Search..."
              clearable
            ></el-input> -->
            <el-select
              v-model="pager.search"
              placeholder="Search by Part No"
              filterable
              clearable
              @change="fetch"
            >
              <el-option
                v-for="item in glossary"
                :key="item.id"
                :value="item.part_no"
                :label="item.part_no"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <!-- <el-input
              v-model="pager.search"
              placeholder="Search..."
              clearable
            ></el-input> -->
            <el-select
              v-model="pager.search"
              placeholder="Search by Description"
              filterable
              clearable
              @change="fetch"
            >
              <el-option
                v-for="item in glossary"
                :key="item.id"
                :value="item.part_no"
                :label="'[' + item.part_no + '] ' + item.description"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-button size="small" type="primary" @click="fetch(1)"
            >Search</el-button
          >
        <el-button size="small" type="primary" @click="download" >Download Parts</el-button>
        </el-form>
      </el-col>
    </el-row>
    <el-table
      :data="list.data"
      v-loading="isLoading"
      empty-text="No records found."
    >
      <el-table-column label="Actions" width="140">
        <template slot-scope="scope">
          <router-link
            class="el-button el-button--primary el-button--small is-circle"
            :to="{ name: 'parts_info', params: { id: scope.row.id } }"
            title="View part information"
            ><i class="el-icon-folder-opened"></i>
          </router-link>
          <router-link
            v-if="user.isRole([1, 2])"
            class="el-button el-button--primary el-button--small is-circle"
            :to="{ name: 'request_info', query: { part_id: scope.row.id } }"
            title="Request for new stocks"
            ><i class="el-icon-position"></i>
          </router-link>
          <!-- <el-button size="small" type="primary"  icon="el-icon-folder-opened" circle></el-button> -->
          <el-button
            v-if="user.isRole([1, 2])"
            size="small"
            type="danger"
            icon="el-icon-delete"
            @click="itemDelete(scope.row.id)"
            title="Delete part"
            circle
          ></el-button>
        </template>
      </el-table-column>
      <el-table-column label="Part No." width="120" prop="part_no" />
      <el-table-column label="Description" prop="description" />
      <el-table-column label="Location" width="150" prop="location" />
      <el-table-column label="Status" width="80" prop="status" />
      <el-table-column label="Date Created" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.created_at | dateFormat }}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-show="!isLoading"
      class="pt-1"
      background
      layout="prev, pager, next"
      :total="list.paging.total"
      :page-size="pager.limit"
      :current-page="parseInt(list.paging.cur_page)"
      @current-change="fetch"
    ></el-pagination>
  </div>
</template>

<script>
import api from "@/api";
export default {
  name: "parts_list",
  computed: {
    user() {
      return this.$store.getters["auth/user"];
    },
    list() {
      return this.$store.getters["part/list"];
    },
    glossary() {
      return this.$store.getters["part/glossary"];
    },
    api() {
      return {
        headers: {
          // "Content-Type": "multipart/form-data",
          Authorization: `${this.$store.getters["auth/token"].token_type} ${this.$store.getters["auth/token"].access_token}`,
          "X-Requested-With": "XMLHttpRequest"
        },
        href: new URL("/api/v1/parts/upload/", api.baseUrl).href
      };
    }
  },
  data() {
    return {
      isLoading: false,
      pager: {
        page: 1,
        limit: 15,
        search: ""
      },
      fileList: []
    };
  },
  methods: {
    fetch(page) {
      this.pager.page = page;
      this.isLoading = true;
      var params = { ...this.pager };
      // if (!this.pager.search) delete params.search;
      this.$store.dispatch("part/getList", params).then(() => {
        this.isLoading = false;
      });
    },
    download() {
      var reportInfo = {
          name: "Parts list",
          ext: ".csv"
      };
      let url = `/api/v1/parts/index/?limit=-1`
      api.download(url, reportInfo).then(() => {
          this.isLoading = false;
          this.btnDisable = false;
      });
    },
    itemDelete(id) {
      this.$confirm("Are you sure you want to delete this part?", {
        confirmButtonText: "Yes",
        cancelButtonText: "No"
      })
        .then(() => {
          this.isLoading = true;
          this.$store.dispatch("part/delete", id).then(resp => {
            if (!resp.msg)
              this.$notify({
                type: "danger",
                message: "Delete failed.",
                position: "bottom-right"
              });
            else
              this.$notify({
                type: "success",
                message: "Part deleted successfully.",
                position: "bottom-right"
              });
            this.isLoading = false;
          });
        })
        .catch(() => {});
    },
    handleSuccess(resp) {
      if (resp.data.errors && resp.data.errors.length != 0) {
        console.error(resp.data.errors);
        this.$notify({
          type: "error",
          message:
            "Error encountered during processing of batch upload. Please see your browser console.",
          position: "bottom-right"
        });
      } else {
        if (resp.data.code == 200) {
          this.fetch(1);
          this.$notify({
            type: "success",
            message: "Parts batch upload success.",
            position: "bottom-right"
          });
        } else {
          this.$notify({
            type: "error",
            message: resp.data.msg,
            position: "bottom-right"
          });
        }
      }
    }
  },
  mounted() {
    this.$store.dispatch("part/getGlossary");
    this.fetch(1);
  }
};
</script>

<style lang="css" scoped></style>
